import axios from 'axios'
import reportErrorToBackend from './report-error-to-backend'

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    reportErrorToBackend(error)
    return Promise.reject(error)
  }
)

export default axiosInstance
